// api
import { getPostTopApi } from '../../../api/posts';
import moment from 'moment';

export default {
  data() {
    return {
      authorLimit: 30,
      textLimit: 65,
      startTime: '00:00:00',
      endTime: '23:59:59',
      format: 'YYYY-MM-DD',
      reqPending: false,
    };
  },
  methods: {
    getPostTop() {
      this.reqPending = true;

      const params = {
        thread_id: this.$route.params.id,
        network_id: this.social.id,
        post_count: this.postCount,
        from: this.setDateTime(this.startTime),
        to: this.setDateTime(this.endTime),
      };

      getPostTopApi(params)
        .then((response) => {
          this.dataCollection = response.data;
          this.reqPending = false;
        })
        .catch(err => err);
    },
    setDateTime(time) {
      return `${moment().format(this.format)} ${time}`;
    },
    sliceText(text) {
      return `${text.slice(0, this.textLimit).trim()}...`;
    },
    sliceAuthor(string) {
      if (string.length <= this.authorLimit) {
        return string;
      }
      return `${string.slice(0, this.authorLimit).trim()}...`;
    },
    toDate(date) {
      return moment(date).format('HH:mm DD.MM.YYYY');
    },
  },
  watch: {
    $route(val) {
      if (val.params.threadName) {
        this.getPostTop();
      }
    },
  },
  mounted() {
    this.getPostTop();
  },
};
